import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import LocationCreateForm from '~/containers/locationCreate/locationCreate';

export class LocationCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/settings/locations`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/settings/locations" backText="Locations" title="Add location" button={cancelButton} />
        <LocationCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(LocationCreatePage));



// WEBPACK FOOTER //
// ./src/pages/locationCreate/locationCreate.jsx